/**
 *
 *
 *
 *
 *
 *
 */

/**
 *
 */
export const PAGE_CLUSTER = {
    /*                      */
    SEARCH_RESULTS: 'Suchergebnisseite',
    /*                             */
    PRODUCT_LIST: 'Produktliste',
    /*                                       */
    TOPIC_PAGE: 'Themenseite',
} as const;

export type PageCluster = (typeof PAGE_CLUSTER)[keyof typeof PAGE_CLUSTER];

export function isSearchResultsPage(pageCluster: string | undefined): boolean {
    return pageCluster === PAGE_CLUSTER.SEARCH_RESULTS;
}

/**
 *
 */
export function isProductListPage(pageCluster: string | undefined): boolean {
    return pageCluster === PAGE_CLUSTER.PRODUCT_LIST;
}

/**
 *
 */
export function isTopicPage(pageCluster: string | undefined): boolean {
    return pageCluster === PAGE_CLUSTER.TOPIC_PAGE;
}

/**
 *
 *
 */
export function isSearchOrProductListPage(pageCluster: string | undefined): boolean {
    return isSearchResultsPage(pageCluster) || isProductListPage(pageCluster);
}
